import Button from "@material-ui/core/Button";
import {Grid} from "@material-ui/core";
import React from "react";
import i18n from "../../../../i18nextInitiator";

const t = i18n.getFixedT('fa','general');

const CallProviderBtn = props => {
    return <Grid item>
        <Button href={`tel:${props.driver.phone}`} variant="contained" color="primary" size={"small"} fullWidth>
            {t('invoice.call-driver')}
        </Button>
    </Grid>
}
export default CallProviderBtn